import { MdHomeWork, MdOutlineBeachAccess } from "react-icons/md";
import { HiHomeModern } from "react-icons/hi2";
import { GiFlowerHat, GiWatermelon, GiSpookyHouse, 
    GiModernCity, GiFamilyHouse, GiCoffeeCup,
    GiMountainCave, GiPalmTree, GiIsland,
    GiCircleForest, GiParkBench, GiVikingLonghouse,
    GiWoodCabin, GiSailboat
} from "react-icons/gi";
import { FaSwimmingPool } from "react-icons/fa";

import { TbBuildingWarehouse } from "react-icons/tb";
export const TabData = [
    {
        id: 1,
        value: "Shared homes",
        img: <MdHomeWork size={20} color="#717171"/>
    },
    {
        id: 2,
        value: "OMG!",
        img: <GiFlowerHat size={20} color="#717171"/>
    },
    {
        id: 3,
        value: "Beach",
        img: <MdOutlineBeachAccess size={20} color="#717171"/>
    },
    {
        id: 4,
        value: "Lake",
        img: <GiWatermelon size={20} color="#717171"/>
    },
    {
        id: 5,
        value: "Countryside",
        img: <GiSpookyHouse size={20} color="#717171"/>
    },
    {
        id: 6,
        value: "Iconic cities",
        img: <GiModernCity size={20} color="#717171"/>
    },
    {
        id: 7,
        value: "Design",
        img: <HiHomeModern size={20} color="#717171"/>
    },
    {
        id: 8,
        value: "bed & breakfasts",
        img: <GiCoffeeCup size={20} color="#717171"/>
    },
    {
        id: 9,
        value: "Mansions",
        img: <GiFamilyHouse size={20} color="#717171"/>
    },
    {
        id: 10,
        value: "Amazing pools",
        img: <FaSwimmingPool size={20} color="#717171"/>
    },
    {
        id: 11,
        value: "Caves",
        img: <GiMountainCave size={20} color="#717171"/>
    },
    {
        id: 12,
        value: "Tropical",
        img: <GiPalmTree size={20} color="#717171"/>
    },
    {
        id: 13,
        value: "Islands",
        img: <GiIsland size={20} color="#717171"/>
    },
    {
        id: 14,
        value: "Tiny homes",
        img: <TbBuildingWarehouse size={20} color="#717171"/>
    },
    {
        id: 15,
        value: "Artic",
        img: <GiCircleForest size={20} color="#717171"/>
    },
    {
        id: 16,
        value: "National parks",
        img: <GiParkBench size={20} color="#717171"/>
    },
    {
        id: 17,
        value: "Cycladic homes",
        img: <GiVikingLonghouse size={20} color="#717171"/>
    },
    {
        id: 18,
        value: "Cabins",
        img: <GiWoodCabin size={20} color="#717171"/>
    },
    {
        id: 19,
        value: "Boats",
        img: <GiSailboat size={20} color="#717171"/>
    }
]

export const sharedHomesData = [
    {
        id: 1,
        location: "Lagos, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-652069874940825047/original/181c33b9-a9bc-44c8-a0fc-2298078f7adf.png?im_w=720",
        host: "Arthur",
        date: "Oct 20 - 25",
        amount: 35,
        rating: "5.0",
        like: true
    },
    {
        id: 2,
        location: "Lagos, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-667226530114161275/original/564e8741-c3a2-4adb-8616-481ae75fdc1d.jpeg?im_w=720",
        host: "Val",
        date: "Oct 20 - 30",
        amount: 25,
        rating: "2.5",
        like: false
    },
    {
        id: 3,
        location: "Cotonou, Benin",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-677222836011650873/original/4f444362-cc27-401b-bfc4-c93ff7ee35f9.jpeg?im_w=720",
        host: "Jake",
        date: "Oct 20 - 24",
        amount: 55,
        rating: "4.5"
    },
    {
        id: 4,
        location: "Lekki, Nigeria",
        img: "https://a0.muscache.com/im/pictures/20e30a36-4712-42d2-a252-ce3b5140752f.jpg?im_w=720",
        host: "Jennifer",
        date: "Nov 1 - 3",
        amount: 213,
        rating: "5.0"
    },
    {
        id: 5,
        location: "Ogba, Nigeria",
        img: "https://a0.muscache.com/im/pictures/75553a50-af24-4cb8-a2bc-bd075c29f2b6.jpg?im_w=720",
        host: "Ade",
        date: "Nov 3 - 9",
        amount: 125,
        rating: "3.5"
    },
    {
        id: 6,
        location: "Oshodi, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-42510273/original/359d754a-746f-4ebf-b823-6de804bdd89b.jpeg?im_w=720",
        host: "Musa",
        date: "Oct 21 - 24",
        amount: 25,
        rating: "2.5"
    },
    {
        id: 7,
        location: "Berger, Benin",
        img: "https://a0.muscache.com/im/pictures/24f1a09d-8c43-453a-8b6f-202e0e14cac3.jpg?im_w=720",
        host: "Jillo",
        date: "Oct 2 - 4",
        amount: 65,
        rating: "4.5"
    },
    {
        id: 8,
        location: "Lekki, Nigeria",
        img: "https://a0.muscache.com/im/pictures/c6c6a8b1-0e98-4006-b8ee-989c43761856.jpg?im_w=720",
        host: "Emeka",
        date: "Dec 1 - 3",
        amount: 213,
        rating: "5.0"
    },
    {
        id: 9,
        location: "Ikeja, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-562495311024030832/original/b49f8185-135a-444b-ade2-67a3833c19fc.jpeg?im_w=720",
        host: "Abbey",
        date: "Nov 3 - 9",
        amount: 85,
        rating: "4.5"
    },
    {
        id: 10,
        location: "Shomolu, Nigeria",
        img: "https://a0.muscache.com/im/pictures/8d16dd0c-af96-4c9c-8957-efe1883b1003.jpg?im_w=720",
        host: "Deborah",
        date: "Nov 21 - 24",
        amount: 225,
        rating: "3.5"
    },
    {
        id: 11,
        location: "Berger, Benin",
        img: "https://a0.muscache.com/im/pictures/5ba85a2b-ea08-4573-9b29-a0e81e91eb08.jpg?im_w=720",
        host: "Philip",
        date: "Oct 13 - 17",
        amount: 165,
        rating: "4.5"
    },
    {
        id: 12,
        location: "Victoria Island, Nigeria",
        img: "https://a0.muscache.com/im/pictures/d297745c-87b2-4b49-84f8-210f93ae6983.jpg?im_w=720",
        host: "Sylvester",
        date: "Nov 1 - 3",
        amount: 1015,
        rating: "5.0"
    },
    {
        id: 13,
        location: "Surulere, Nigeria",
        img: "https://a0.muscache.com/im/pictures/f84a0fac-83d1-49dc-b782-f8f46c4ac3bb.jpg?im_w=720",
        host: "Adamu",
        date: "Dec 1 - 14",
        amount: 105,
        rating: "4.8"
    },
    {
        id: 14,
        location: "Lagos, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-667226530114161275/original/564e8741-c3a2-4adb-8616-481ae75fdc1d.jpeg?im_w=720",
        host: "Val",
        date: "Oct 20 - 30",
        amount: 25,
        rating: "2.5"
    },
    {
        id: 15,
        location: "Cotonou, Benin",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-677222836011650873/original/4f444362-cc27-401b-bfc4-c93ff7ee35f9.jpeg?im_w=720",
        host: "Jake",
        date: "Oct 20 - 24",
        amount: 55,
        rating: "4.5"
    },
    {
        id: 16,
        location: "Lekki, Nigeria",
        img: "https://a0.muscache.com/im/pictures/20e30a36-4712-42d2-a252-ce3b5140752f.jpg?im_w=720",
        host: "Jennifer",
        date: "Nov 1 - 3",
        amount: 213,
        rating: "5.0"
    },
    {
        id: 17,
        location: "Ogba, Nigeria",
        img: "https://a0.muscache.com/im/pictures/75553a50-af24-4cb8-a2bc-bd075c29f2b6.jpg?im_w=720",
        host: "Ade",
        date: "Nov 3 - 9",
        amount: 125,
        rating: "3.5"
    },
    {
        id: 18,
        location: "Oshodi, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-42510273/original/359d754a-746f-4ebf-b823-6de804bdd89b.jpeg?im_w=720",
        host: "Musa",
        date: "Oct 21 - 24",
        amount: 25,
        rating: "2.5"
    },
    {
        id: 19,
        location: "Berger, Benin",
        img: "https://a0.muscache.com/im/pictures/24f1a09d-8c43-453a-8b6f-202e0e14cac3.jpg?im_w=720",
        host: "Jillo",
        date: "Oct 2 - 4",
        amount: 65,
        rating: "4.5"
    },
    {
        id: 20,
        location: "Lekki, Nigeria",
        img: "https://a0.muscache.com/im/pictures/c6c6a8b1-0e98-4006-b8ee-989c43761856.jpg?im_w=720",
        host: "Emeka",
        date: "Dec 1 - 3",
        amount: 213,
        rating: "5.0"
    },
]
export const OMGData = [
    {
        id: 1,
        location: "Lagos, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-652069874940825047/original/181c33b9-a9bc-44c8-a0fc-2298078f7adf.png?im_w=720",
        host: "Chika",
        date: "Oct 10 - 30",
        amount: 55,
        rating: "4.5"
    },
    {
        id: 2,
        location: "Lagos, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-630833584124942969/original/930406b3-9f15-4795-987c-0b1a9934cc41.jpeg?im_w=720",
        host: "Val",
        date: "Oct 20 - 30",
        amount: 25,
        rating: "2.5"
    },
    {
        id: 3,
        location: "Cotonou, Benin",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-50591209/original/cb4e654a-2782-4b7f-9f79-51fe68611bb4.jpeg?im_w=720",
        host: "Jake",
        date: "Oct 20 - 24",
        amount: 55,
        rating: "4.5"
    },
    {
        id: 4,
        location: "Lekki, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-713776262602644180/original/42ea61f3-1e85-47b4-958b-3ff4104fe2a0.jpeg?im_w=720",
        host: "Jennifer",
        date: "Nov 1 - 3",
        amount: 213,
        rating: "5.0"
    },
    {
        id: 5,
        location: "Ogba, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-652069874940825047/original/181c33b9-a9bc-44c8-a0fc-2298078f7adf.png?im_w=720",
        host: "Ade",
        date: "Nov 3 - 9",
        amount: 125,
        rating: "3.5"
    },
    {
        id: 6,
        location: "Oshodi, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-630833584124942969/original/930406b3-9f15-4795-987c-0b1a9934cc41.jpeg?im_w=720",
        host: "Musa",
        date: "Oct 21 - 24",
        amount: 25,
        rating: "2.5"
    },
    {
        id: 7,
        location: "Berger, Benin",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-50591209/original/cb4e654a-2782-4b7f-9f79-51fe68611bb4.jpeg?im_w=720",
        host: "Jillo",
        date: "Oct 2 - 4",
        amount: 65,
        rating: "4.5"
    },
    {
        id: 8,
        location: "Lekki, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-713776262602644180/original/42ea61f3-1e85-47b4-958b-3ff4104fe2a0.jpeg?im_w=720",
        host: "Emeka",
        date: "Dec 1 - 3",
        amount: 213,
        rating: "5.0"
    },
    {
        id: 9,
        location: "Ikeja, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-652069874940825047/original/181c33b9-a9bc-44c8-a0fc-2298078f7adf.png?im_w=720",
        host: "Abbey",
        date: "Nov 3 - 9",
        amount: 85,
        rating: "4.5"
    },
    {
        id: 10,
        location: "Shomolu, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-630833584124942969/original/930406b3-9f15-4795-987c-0b1a9934cc41.jpeg?im_w=720",
        host: "Deborah",
        date: "Nov 21 - 24",
        amount: 225,
        rating: "3.5"
    },
    {
        id: 11,
        location: "Berger, Benin",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-50591209/original/cb4e654a-2782-4b7f-9f79-51fe68611bb4.jpeg?im_w=720",
        host: "Philip",
        date: "Oct 13 - 17",
        amount: 165,
        rating: "4.5"
    },
    {
        id: 12,
        location: "Victoria Island, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-713776262602644180/original/42ea61f3-1e85-47b4-958b-3ff4104fe2a0.jpeg?im_w=720",
        host: "Sylvester",
        date: "Nov 1 - 3",
        amount: 1015,
        rating: "5.0"
    },
    {
        id: 13,
        location: "Surulere, Nigeria",
        img: "https://a0.muscache.com/im/pictures/f84a0fac-83d1-49dc-b782-f8f46c4ac3bb.jpg?im_w=720",
        host: "Adamu",
        date: "Dec 1 - 14",
        amount: 105,
        rating: "4.8"
    },
    {
        id: 14,
        location: "Lagos, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-667226530114161275/original/564e8741-c3a2-4adb-8616-481ae75fdc1d.jpeg?im_w=720",
        host: "Val",
        date: "Oct 20 - 30",
        amount: 25,
        rating: "2.5"
    },
    {
        id: 15,
        location: "Cotonou, Benin",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-677222836011650873/original/4f444362-cc27-401b-bfc4-c93ff7ee35f9.jpeg?im_w=720",
        host: "Jake",
        date: "Oct 20 - 24",
        amount: 55,
        rating: "4.5"
    },
    {
        id: 16,
        location: "Lekki, Nigeria",
        img: "https://a0.muscache.com/im/pictures/20e30a36-4712-42d2-a252-ce3b5140752f.jpg?im_w=720",
        host: "Jennifer",
        date: "Nov 1 - 3",
        amount: 213,
        rating: "5.0"
    },
    {
        id: 17,
        location: "Ogba, Nigeria",
        img: "https://a0.muscache.com/im/pictures/75553a50-af24-4cb8-a2bc-bd075c29f2b6.jpg?im_w=720",
        host: "Ade",
        date: "Nov 3 - 9",
        amount: 125,
        rating: "3.5"
    },
    {
        id: 18,
        location: "Oshodi, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-42510273/original/359d754a-746f-4ebf-b823-6de804bdd89b.jpeg?im_w=720",
        host: "Musa",
        date: "Oct 21 - 24",
        amount: 25,
        rating: "2.5"
    },
    {
        id: 19,
        location: "Berger, Benin",
        img: "https://a0.muscache.com/im/pictures/24f1a09d-8c43-453a-8b6f-202e0e14cac3.jpg?im_w=720",
        host: "Jillo",
        date: "Oct 2 - 4",
        amount: 65,
        rating: "4.5"
    },
    {
        id: 20,
        location: "Lekki, Nigeria",
        img: "https://a0.muscache.com/im/pictures/c6c6a8b1-0e98-4006-b8ee-989c43761856.jpg?im_w=720",
        host: "Emeka",
        date: "Dec 1 - 3",
        amount: 213,
        rating: "5.0"
    },
]
export const BeachData = [
    {
        id: 1,
        location: "Ikeja, Nigeria",
        img: "https://a0.muscache.com/im/pictures/81f5b8cf-9264-4f30-8baa-e2ef6eb35635.jpg?im_w=720",
        host: "Jide",
        date: "Oct 3 - 7",
        amount: 15,
        rating: "3.5"
    },
    {
        id: 2,
        location: "Lagos, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-630833584124942969/original/930406b3-9f15-4795-987c-0b1a9934cc41.jpeg?im_w=720",
        host: "Val",
        date: "Oct 20 - 30",
        amount: 25,
        rating: "2.5"
    },
    {
        id: 3,
        location: "Cotonou, Benin",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-50591209/original/cb4e654a-2782-4b7f-9f79-51fe68611bb4.jpeg?im_w=720",
        host: "Jake",
        date: "Oct 20 - 24",
        amount: 55,
        rating: "4.5"
    },
    {
        id: 4,
        location: "Lekki, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-713776262602644180/original/42ea61f3-1e85-47b4-958b-3ff4104fe2a0.jpeg?im_w=720",
        host: "Jennifer",
        date: "Nov 1 - 3",
        amount: 213,
        rating: "5.0"
    },
    {
        id: 5,
        location: "Ogba, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-652069874940825047/original/181c33b9-a9bc-44c8-a0fc-2298078f7adf.png?im_w=720",
        host: "Ade",
        date: "Nov 3 - 9",
        amount: 125,
        rating: "3.5"
    },
    {
        id: 6,
        location: "Oshodi, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-630833584124942969/original/930406b3-9f15-4795-987c-0b1a9934cc41.jpeg?im_w=720",
        host: "Musa",
        date: "Oct 21 - 24",
        amount: 25,
        rating: "2.5"
    },
    {
        id: 7,
        location: "Berger, Benin",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-50591209/original/cb4e654a-2782-4b7f-9f79-51fe68611bb4.jpeg?im_w=720",
        host: "Jillo",
        date: "Oct 2 - 4",
        amount: 65,
        rating: "4.5"
    },
    {
        id: 8,
        location: "Lekki, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-713776262602644180/original/42ea61f3-1e85-47b4-958b-3ff4104fe2a0.jpeg?im_w=720",
        host: "Emeka",
        date: "Dec 1 - 3",
        amount: 213,
        rating: "5.0"
    },
    {
        id: 9,
        location: "Ikeja, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-652069874940825047/original/181c33b9-a9bc-44c8-a0fc-2298078f7adf.png?im_w=720",
        host: "Abbey",
        date: "Nov 3 - 9",
        amount: 85,
        rating: "4.5"
    },
    {
        id: 10,
        location: "Shomolu, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-630833584124942969/original/930406b3-9f15-4795-987c-0b1a9934cc41.jpeg?im_w=720",
        host: "Deborah",
        date: "Nov 21 - 24",
        amount: 225,
        rating: "3.5"
    },
    {
        id: 11,
        location: "Berger, Benin",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-50591209/original/cb4e654a-2782-4b7f-9f79-51fe68611bb4.jpeg?im_w=720",
        host: "Philip",
        date: "Oct 13 - 17",
        amount: 165,
        rating: "4.5"
    },
    {
        id: 12,
        location: "Victoria Island, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-713776262602644180/original/42ea61f3-1e85-47b4-958b-3ff4104fe2a0.jpeg?im_w=720",
        host: "Sylvester",
        date: "Nov 1 - 3",
        amount: 1015,
        rating: "5.0"
    },
    {
        id: 13,
        location: "Surulere, Nigeria",
        img: "https://a0.muscache.com/im/pictures/f84a0fac-83d1-49dc-b782-f8f46c4ac3bb.jpg?im_w=720",
        host: "Adamu",
        date: "Dec 1 - 14",
        amount: 105,
        rating: "4.8"
    },
    {
        id: 14,
        location: "Lagos, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-667226530114161275/original/564e8741-c3a2-4adb-8616-481ae75fdc1d.jpeg?im_w=720",
        host: "Val",
        date: "Oct 20 - 30",
        amount: 25,
        rating: "2.5"
    },
    {
        id: 15,
        location: "Cotonou, Benin",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-677222836011650873/original/4f444362-cc27-401b-bfc4-c93ff7ee35f9.jpeg?im_w=720",
        host: "Jake",
        date: "Oct 20 - 24",
        amount: 55,
        rating: "4.5"
    },
    {
        id: 16,
        location: "Lekki, Nigeria",
        img: "https://a0.muscache.com/im/pictures/20e30a36-4712-42d2-a252-ce3b5140752f.jpg?im_w=720",
        host: "Jennifer",
        date: "Nov 1 - 3",
        amount: 213,
        rating: "5.0"
    },
    {
        id: 17,
        location: "Ogba, Nigeria",
        img: "https://a0.muscache.com/im/pictures/75553a50-af24-4cb8-a2bc-bd075c29f2b6.jpg?im_w=720",
        host: "Ade",
        date: "Nov 3 - 9",
        amount: 125,
        rating: "3.5"
    },
    {
        id: 18,
        location: "Oshodi, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-42510273/original/359d754a-746f-4ebf-b823-6de804bdd89b.jpeg?im_w=720",
        host: "Musa",
        date: "Oct 21 - 24",
        amount: 25,
        rating: "2.5"
    },
    {
        id: 19,
        location: "Berger, Benin",
        img: "https://a0.muscache.com/im/pictures/24f1a09d-8c43-453a-8b6f-202e0e14cac3.jpg?im_w=720",
        host: "Jillo",
        date: "Oct 2 - 4",
        amount: 65,
        rating: "4.5"
    },
    {
        id: 20,
        location: "Lekki, Nigeria",
        img: "https://a0.muscache.com/im/pictures/c6c6a8b1-0e98-4006-b8ee-989c43761856.jpg?im_w=720",
        host: "Emeka",
        date: "Dec 1 - 3",
        amount: 213,
        rating: "5.0"
    },
]
export const LakeData = [
    {
        id: 1,
        location: "Surulere, Nigeria",
        img: "https://a0.muscache.com/im/pictures/f84a0fac-83d1-49dc-b782-f8f46c4ac3bb.jpg?im_w=720",
        host: "Adamu",
        date: "Dec 1 - 14",
        amount: 105,
        rating: "4.8"
    },
    {
        id: 2,
        location: "Lagos, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-667226530114161275/original/564e8741-c3a2-4adb-8616-481ae75fdc1d.jpeg?im_w=720",
        host: "Val",
        date: "Oct 20 - 30",
        amount: 25,
        rating: "2.5"
    },
    {
        id: 3,
        location: "Cotonou, Benin",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-677222836011650873/original/4f444362-cc27-401b-bfc4-c93ff7ee35f9.jpeg?im_w=720",
        host: "Jake",
        date: "Oct 20 - 24",
        amount: 55,
        rating: "4.5"
    },
    {
        id: 4,
        location: "Lekki, Nigeria",
        img: "https://a0.muscache.com/im/pictures/20e30a36-4712-42d2-a252-ce3b5140752f.jpg?im_w=720",
        host: "Jennifer",
        date: "Nov 1 - 3",
        amount: 213,
        rating: "5.0"
    },
    {
        id: 5,
        location: "Ogba, Nigeria",
        img: "https://a0.muscache.com/im/pictures/75553a50-af24-4cb8-a2bc-bd075c29f2b6.jpg?im_w=720",
        host: "Ade",
        date: "Nov 3 - 9",
        amount: 125,
        rating: "3.5"
    },
    {
        id: 6,
        location: "Oshodi, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-42510273/original/359d754a-746f-4ebf-b823-6de804bdd89b.jpeg?im_w=720",
        host: "Musa",
        date: "Oct 21 - 24",
        amount: 25,
        rating: "2.5"
    },
    {
        id: 7,
        location: "Berger, Benin",
        img: "https://a0.muscache.com/im/pictures/24f1a09d-8c43-453a-8b6f-202e0e14cac3.jpg?im_w=720",
        host: "Jillo",
        date: "Oct 2 - 4",
        amount: 65,
        rating: "4.5"
    },
    {
        id: 8,
        location: "Lekki, Nigeria",
        img: "https://a0.muscache.com/im/pictures/c6c6a8b1-0e98-4006-b8ee-989c43761856.jpg?im_w=720",
        host: "Emeka",
        date: "Dec 1 - 3",
        amount: 213,
        rating: "5.0"
    },
    {
        id: 9,
        location: "Ikeja, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-562495311024030832/original/b49f8185-135a-444b-ade2-67a3833c19fc.jpeg?im_w=720",
        host: "Abbey",
        date: "Nov 3 - 9",
        amount: 85,
        rating: "4.5"
    },
    {
        id: 10,
        location: "Shomolu, Nigeria",
        img: "https://a0.muscache.com/im/pictures/8d16dd0c-af96-4c9c-8957-efe1883b1003.jpg?im_w=720",
        host: "Deborah",
        date: "Nov 21 - 24",
        amount: 225,
        rating: "3.5"
    },
    {
        id: 11,
        location: "Berger, Benin",
        img: "https://a0.muscache.com/im/pictures/5ba85a2b-ea08-4573-9b29-a0e81e91eb08.jpg?im_w=720",
        host: "Philip",
        date: "Oct 13 - 17",
        amount: 165,
        rating: "4.5"
    },
    {
        id: 12,
        location: "Victoria Island, Nigeria",
        img: "https://a0.muscache.com/im/pictures/d297745c-87b2-4b49-84f8-210f93ae6983.jpg?im_w=720",
        host: "Sylvester",
        date: "Nov 1 - 3",
        amount: 1015,
        rating: "5.0"
    },
    {
        id: 13,
        location: "Surulere, Nigeria",
        img: "https://a0.muscache.com/im/pictures/f84a0fac-83d1-49dc-b782-f8f46c4ac3bb.jpg?im_w=720",
        host: "Adamu",
        date: "Dec 1 - 14",
        amount: 105,
        rating: "4.8"
    },
    {
        id: 14,
        location: "Lagos, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-667226530114161275/original/564e8741-c3a2-4adb-8616-481ae75fdc1d.jpeg?im_w=720",
        host: "Val",
        date: "Oct 20 - 30",
        amount: 25,
        rating: "2.5"
    },
    {
        id: 15,
        location: "Cotonou, Benin",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-677222836011650873/original/4f444362-cc27-401b-bfc4-c93ff7ee35f9.jpeg?im_w=720",
        host: "Jake",
        date: "Oct 20 - 24",
        amount: 55,
        rating: "4.5"
    },
    {
        id: 16,
        location: "Lekki, Nigeria",
        img: "https://a0.muscache.com/im/pictures/20e30a36-4712-42d2-a252-ce3b5140752f.jpg?im_w=720",
        host: "Jennifer",
        date: "Nov 1 - 3",
        amount: 213,
        rating: "5.0"
    },
    {
        id: 17,
        location: "Ogba, Nigeria",
        img: "https://a0.muscache.com/im/pictures/75553a50-af24-4cb8-a2bc-bd075c29f2b6.jpg?im_w=720",
        host: "Ade",
        date: "Nov 3 - 9",
        amount: 125,
        rating: "3.5"
    },
    {
        id: 18,
        location: "Oshodi, Nigeria",
        img: "https://a0.muscache.com/im/pictures/miso/Hosting-42510273/original/359d754a-746f-4ebf-b823-6de804bdd89b.jpeg?im_w=720",
        host: "Musa",
        date: "Oct 21 - 24",
        amount: 25,
        rating: "2.5"
    },
    {
        id: 19,
        location: "Berger, Benin",
        img: "https://a0.muscache.com/im/pictures/24f1a09d-8c43-453a-8b6f-202e0e14cac3.jpg?im_w=720",
        host: "Jillo",
        date: "Oct 2 - 4",
        amount: 65,
        rating: "4.5"
    },
    {
        id: 20,
        location: "Lekki, Nigeria",
        img: "https://a0.muscache.com/im/pictures/c6c6a8b1-0e98-4006-b8ee-989c43761856.jpg?im_w=720",
        host: "Emeka",
        date: "Dec 1 - 3",
        amount: 213,
        rating: "5.0"
    },
]